<template>
  <v-container class="pa-0">
    <v-btn-toggle
      v-model="idx"
      mandatory
      borderless
      color="primary"
      class="d-flex flex-wrap justify-center"
    >
      <v-icon class="mr-3">
        {{ currencyIcon }}
      </v-icon>
      <v-btn
        v-for="(price, i) in prices"
        :key="i"
      >
        {{ price.amount }}
      </v-btn>

      <v-btn
        v-if="subscription.allow_custom_price"
        @click="triggerCustom"
      >
        Custom
      </v-btn>
    </v-btn-toggle>

    <v-expand-transition>
      <v-text-field
        v-if="custom"
        ref="amount"
        v-model="amount"
        class="mt-3"
        :prepend-icon="currencyIcon"
        hint="Amount"
        persistent-hint
        :rules="[rules.required, rules.number]"
        :readonly="!enterCustomAmount"
        @keyup="$emit('dump', {amount: Number.parseFloat(amount), useClientAmount: true})"
      />
    </v-expand-transition>
  </v-container>
</template>

<script>
export default {
  props: {
    subscription: {
      type: Object,
      default: ()=>{return {}}
    },
    currencyIcon: {
      type: String,
      default: ()=>""
    },
  },
  data(){
    return {
      idx: 0,
      amount: null,
      enterCustomAmount: false,
      rules: {
        required: value => !!value || 'Required',
        number: value => (!isNaN(value)) || 'Number Only'
      }
    }
  },
  computed: {
    prices(){return (this.subscription.prices || []).filter((p)=>{
      return p.enabled
    }) || []},
    custom(){return !this.prices[this.idx] && this.idx > 0}
  },
  watch:{
    subscription(){
      this.idx = 0
      this.setAmount(0)
    },
    idx(i){
      this.setAmount(i)
    }
  },
  mounted(){
    this.setAmount(0)
  },
  methods: {
    triggerCustom(){
      this.enterCustomAmount = true
      window.setTimeout(() => {
        this.$refs.amount.focus()
      })
    },
    setAmount(i){
      let price = this.prices[i]
      if (price) {
        this.enterCustomAmount = false
        this.amount = price.amount
        this.$emit('dump', {
          amount: Number.parseFloat(this.amount),
          useClientAmount: true
        })
      }
    }
  }
}
</script>